import { useGetApiV1ExamClassStudentDropdown } from '@/shared/api/generated';

import type { DropdownOption } from './useCompaniesDropdown';

/**
 * Lista de turmas (class students) para popular filtros de dropdown.
 *
 * @param courseId - Filtra turmas do curso informado (opcional).
 * @param companyId - Filtra turmas da empresa informada (opcional).
 */
export function useClassStudentsDropdown(courseId?: number, companyId?: number) {
  const params: { courseId?: number; companyId?: number } = {};
  if (courseId !== undefined) params.courseId = courseId;
  if (companyId !== undefined) params.companyId = companyId;

  const query = useGetApiV1ExamClassStudentDropdown(
    Object.keys(params).length > 0 ? params : undefined,
  );

  const classes: readonly DropdownOption[] = (query.data ?? []).map(item => ({
    id: String(item.key ?? ''),
    name: item.value ?? '',
  }));

  return {
    classes,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
